import { render, staticRenderFns } from "./ProductiveUnits.vue?vue&type=template&id=7d347000&scoped=true&"
import script from "./ProductiveUnits.vue?vue&type=script&lang=js&"
export * from "./ProductiveUnits.vue?vue&type=script&lang=js&"
import style0 from "./ProductiveUnits.vue?vue&type=style&index=0&id=7d347000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d347000",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VRow,VTooltip})
